<template>
    <div class="ve-list-page ve-list-page--embedded">
    
        <div style=" display:flex; width:100%; background:#fff;line-height:30px;height:38px;border-bottom:2px solid #389;padding-top:3px">   
            <div style="width:70px;line-height:30px" >
                <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:12px;font-weight:600 ">新增 </span></el-link>
            </div>
            <span style="color:black;margin-left:10px;margin-right:5px;font-size:12px">字段查询</span>
       
            <el-select v-model="selparam"  placeholder="请选择列名" filterable  size="small" style="width:120px; ">
                <span v-for="item in tabCol" :key='item.key' >
                    <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                </span>
            </el-select>
            <el-input clearable ref="refinput" :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:320px; height:30px; ">
                <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
            </el-input>
        </div> 
        <el-table  :data="tabData" 
            border                            
            disabled-hover
            class="custom-table-border ve-list-page__table"
            :cell-style="{padding:'4px','font-size':'12px',color:'black'}"
            style="overflow:auto;margin-top:1px;"
            header-cell-class-name="clearPadding"
            size="small"
            v-loading="v_loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            height="100%"
            :row-key="getRowKey"  
            ref="tabref" 
            highlight-current-row>
            <el-table-column label="序号" type="index" width="60" fixed align="center">
                <el-table-column label="序号" type="index" width="60" fixed align="center">
                    <template slot="header"  >
                        <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1"  ></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column  v-for="(item,index ) in tabCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.key!=='RN'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key"  :align="item.align"  show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        <el-select v-if="item.key=='STFG'" @change="qryTabData" v-model="v_row[item.key]" size="mini" placeholder="" filterable clearable style="width:100%; " >
                            <el-option label="是" value="Y"  ></el-option>
                            <el-option label="否" value="N"  ></el-option>
                        </el-select>
                        <el-date-picker v-else-if="item.edcss=='date'" @change="qryTabData" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                        <el-input type="number" placeholder="" @keyup.enter.native="qryTabData" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input>
                        <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="qryTabData"  v-model="v_row[item.key]" size="mini" placeholder="" ></el-input>
                    </template>
                    <template slot-scope="scope">
                        <el-link v-if="item.key=='IDNO'" :underline="false" @click="repBtn(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-tag  v-else-if="item.edcss=='checkbox'&&scope.row[item.key]=='Y'" size="mini" type="success" effect="dark">是</el-tag>
                        <el-tag  v-else-if="item.edcss=='checkbox'&&scope.row[item.key]=='N'" size="mini" type="info" effect="dark">否</el-tag>                         
                        <span v-else v-text="scope.row[item.key]" ></span>
                    </template>
                </el-table-column> 
            </el-table-column> 
            <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="195">
                <template slot-scope="scope">
                    <!-- <span v-if="scope.row.STFG=='Y' ">
                        <i class="iconfont icon-xiashuangjiantou" style="color:#409EFF;font-size:12px;margin-right:3px;"></i>
                        <el-link :disabled="editBool" @click="nextGen(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:2px;">下推 </span></el-link>
                    </span>  -->
                    <i class="iconfont icon-chakan1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link   @click="editRec(scope.row,'Y' )" :underline="false"  ><span style="font-size:12px;margin-right:5px;">查看 </span></el-link>
                    <span v-if="scope.row.STFG==='N' " >
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="editBool" @click="editRec(scope.row,'N')" :underline="false"  ><span style="font-size:12px;margin-right:2px;">编辑 </span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='N' " >
                        <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="cfmBool" @click="stfgRec(scope.row,'Y',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">审核</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='Y' " >
                        <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="cfmBool" @click="stfgRec(scope.row,'N',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">弃审</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='N' " >
                        <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="cancelBool" @click="stfgRec(scope.row,'X',scope.$index)" :underline="false"  ><span style="font-size:12px; ">删除</span></el-link>
                    </span>
                        
                </template>
            </el-table-column>                      
        </el-table>  
        <div class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="drawer" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <span v-for="(gpitem,gpind) in formArr" :key="gpind"  >   
                    <div class="one-toolbar">
                    <span class="spanRow"> {{gpitem.gpnm}} </span>
                    </div>        
                    <Form :model="mainRow" :label-width="120" ref="supForm"  label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">                  
                                <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.EDCSS==='date'" v-model="mainRow[item.FLDNO]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input-number size="medium" :precision="item.DOTNUM" :disabled="saveFlag"  v-else-if="item.EDCSS==='number'" v-model="mainRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                                <el-checkbox size="medium" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                <el-select size="medium" :disabled="item.DISABLED==='Y'?true:false||saveFlag" v-else-if="item.EDCSS==='select'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                </el-select>
                                <el-select size="medium" :disabled="saveFlag" v-else-if="item.FLDNO==='DEPTNO'" v-model="mainRow[item.FLDNO]" filterable  style="width:100%">
                                    <el-option v-for="(item,index) in deptArr " :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                </el-select>                        
                                <el-select size="medium" filterable v-else-if="item.key=='STAFF'||item.key=='STKEMP'" :disabled="saveFlag" style="width:100%" v-model="mainRow[item.FLDNO]">
                                    <el-row v-for="(item,index) in empArr " :key="index">
                                        <el-col :span="6">
                                            <el-option  :label="item.EMPNO" :value="item.USERNM"></el-option>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-option  :label="item.DEPTNM" :value="item.USERNM"></el-option>
                                        </el-col>
                                        <el-col :span="7">
                                            <el-option  :label="item.USERNM" :value="item.USERNM"></el-option>
                                        </el-col>
                                    </el-row>
                                </el-select>
                                
                                <el-input size="medium" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="mainRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </span>
                <div class="one-toolbar">
                    <span class="spanRow"> 投料明细</span>
                    <el-button :disabled="saveFlag" @click="dtlAdd" type="primary" plain size="mini" style="height:25px; border:1px solid #409eff;margin-left:20px">
                        <i class="iconfont icon-icon-choose" style=" font-size:12px;margin-right:3px"></i>选择物料
                    </el-button> 
                </div>
                <el-table  :data="dtlData" 
                    border                            
                    size="small"
                    ref="refdtl"
                    class="custom-table-border"
                    style="margin-top:-6px"
                    :cell-style="{padding:'2px'}"
                    :height="editHeight" 
                    v-loading="v_loading"
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    highlight-current-row
                    @row-click="perClick" >  
                    <el-table-column label="序号" width="60" type="index"></el-table-column>    
                    <el-table-column  v-for="(item ) in dtlCol.filter(item=>item.thide=='N')" :key="item.key"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                        :min-width="item.width">
                        <template slot-scope="scope">
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >                    
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"    v-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <el-input v-else-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                            </span>
                        </template> 
                    </el-table-column> 
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="70">
                        <template slot-scope="scope">
                            <!-- <el-button size="mini" :disabled="saveFlag"  type="text" icon="el-icon-edit" @click="perEdit(scope.row,scope.$index)">编辑</el-button> -->
                            <el-button size="mini" :disabled="saveFlag"  type="text" icon="el-icon-close" @click="perDel(scope.row,scope.$index)">删除</el-button>   
                        </template>
                    </el-table-column>                        
                </el-table>      
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="drawer=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button :disabled="saveFlag" @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button> 
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 明细资料框 -->
        <el-dialog v-dialogDrag  :visible.sync="perWin"  width="1200px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{perFlag==='create'?'新增记录':'编辑记录'}}</span>
            </div>
            <Form :model="dtlRow" :label-width="120"  label-position="right" inline  :rules="dtlValidate">  
                <span v-for="(item,index) in dtlCol" :key="index" >
                    <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                        <el-date-picker type="date"  v-if="item.edcss==='date'" v-model="dtlRow[item.key]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>    
                        <el-input-number  :precision="item.dotnum" :disabled="item.disabled==='Y'?true:false||saveFlag"  v-else-if="item.edcss==='number'" v-model="dtlRow[item.key]" style="width:100%" ></el-input-number>   
 
                        <el-select filterable v-else-if="item.key=='SRCIDSEQ'" @change="ordChg" :disabled="saveFlag" style="width:100%" v-model="dtlRow[item.key]">
                            <div style=" display:flex; border-bottom:1px solid #389;font-size:12px;line-height:30px; ">
                                <div style="width:140px;text-align:center">产品编码</div>
                                <div style="width:140px;text-align:center">产品名称</div>
                                <div style="width:100px;text-align:center">数量</div>
                                <div style="width:140px;text-align:center">订单编码</div>
                            </div>
                            <span v-for="(item,index) in ordArr " :key="index" style="display:flex;  ">
                                <div style="width:140px">
                                    <el-option  :label="item.MATNO" :value="item.PKSEQ"></el-option>
                                </div>
                                <div style="width:140px">
                                    <el-option :title="item.MATNM" :label="item.MATNM" :value="item.PKSEQ"></el-option>
                                </div>
                                <div style="width:100px">
                                    <el-option  :label="item.QTY" :value="item.PKSEQ"></el-option>
                                </div>
                                <div style="width:140px">
                                    <el-option  :label="item.IDNO" :value="item.PKSEQ"></el-option>
                                </div>
                            </span>
                        </el-select>          
                        <el-select @change="comChg(item.key,dtlRow[item.key],comboArr[item.key] )" :disabled="item.disabled==='Y'?true:false||saveFlag" v-else-if="item.edcss==='select'" v-model="dtlRow[item.key]"   style="width:100%">
                            <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                        </el-select>
                        <el-select v-model="dtlRow[item.key]"  v-else-if="item.key==='MATTY'"   style="width:100%">
                            <el-option label="产成品" value="PRD"></el-option>
                            <el-option label="原材料" value="MAT"></el-option>
                        </el-select>
                        <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="dtlRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form> 
            <span slot="footer"  >
                <el-button type="info" @click="perWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                <el-button @click="dtlSure" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button> 
            </span>
        </el-dialog>
 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
 
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog>
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag  v-if="btnWin" :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
    </div>
</template>
<script>
import repWin from '../datamgt/repWin.vue'  
import pubWin from '../datamgt/pub_easy_one.vue'   
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate } from '../../api/Select' 
//局部注册
export default {
    name:"pc_pick_one",
    data () {
        return {
            allSel:'N',
            supval:'',
            dateval:'',
            rmkval:'',
 
            v_row: {},
            v_idno:'',
            v_replist:[],
            repArr:[],
            reqData:[],
            repDlg:false,
            repWin:false,
            repUrl:'',
            supArr:[],
            drawer:false,
  
            perFlag:'create',
            dtlRow:{},
            sendVal:'PRD',
            saveFlag:false,
            empWin:false,
            promptWin:false,
    
            prompt:'',
            selparam3:'IDNO',
            oper3:'like',
            txtparam3:'',
            selparam4:'',
            oper4:'like',
            txtparam4:'',
            tmplRmk:'',
            stfgCss:'',
            perWin:false,
            stfgColor:'',
            mainRow:{},
            input_hold:'请输入查询的值',
 
            active:'', //二级菜单选中标志
            stfg_:'ALL',
            menuBool:false,
            disabled:false, //新增权限制
 
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            dtlValidate:{},
            formArr:[],
            tabData:[], //表数据
            allData:[],
            v_loading:false,
            tabCol:[], //表列
            dtlData:[], //明细数据
            matCol:[], //物料列
            dtlCol:[],
            operArr:[],
            oper:'like',
            oper2:'like',
            comboArr:{},
            txtparam:'',
            selparam:'IDNO',
 
            delArr:[],
            empArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            notDtl:[],
            current:1,
            btnWin:false,
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            deptArr:[],
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            v_stknm :'',
            ordArr:[],
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
      
        }
    },
    mounted () { 
 
        //用户表单新增、编辑、审核、作废权限 :frmid:  ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','407576','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
        //操作符
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });
        getBaseData('xuper_auth/getTableRecMany','corpid',this.v_corpid,'','','hr_frame','').then(res=>{
            this.deptArr =res.result
        })
        getBaseData('xuper_auth/getTableRecMany','corpid',this.v_corpid,'ORDSTFG','Y','V_ORDITM','').then(res=>{
            this.ordArr =res.result
        })
 
        //表单所以下拦框动态赋值
        this.comSelect()
        //供应商
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','v_bs_sup','').then(res=>{
            this.supArr =res.result
        })
        //人员资料
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','V_SYS_USER','').then(res=>{
            this.empArr =res.result
        })
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','407576','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
 
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','407576','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promptWin=true
                this.prompt=res.result
            }
        })
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','407576','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
 
        this.$nextTick(()=>{
            this.$refs['refinput'].focus()
        })
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 340) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        }, 
        reqHeight: function() {
            return (window.innerHeight - 460) + 'px';
        }, 
    },
    components: {
        repWin,
        pubWin,
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.getPcList('')
            this.getTabField() //表列字段
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: { 
        btnSure(obj){
            obj.forEach(item=>{
                let v_bool =true
                this.dtlData.some(dtl=>{
                    if (dtl['MATNO']==item['IDNO']){
                        v_bool =false
                    }
                })
                if (v_bool){
                    let v_obj ={MATNO:item['IDNO'],MATNM:item['MATNM'],MATDESC:item['MATDESC'],MATTYNM:item['MATTYNM'],UNITNM:item['UNITNM'],BOMQTY:'',PRDQTY:'',QTY:'',STKNM:item['STKNM'],STKQTY:'',ACTQTY:'' ,RMK:''}
                    this.dtlData.push(v_obj)
                }
            })   
            this.btnWin =false
        },
        dtlAdd(){
            this.v_table ='v_bs_matqry'
            this.tableCol =this.matCol
            this.v_key2 ='modelno'
            this.v_value2 = 'MAT'
            this.btnWin =true
        },
 
        rowShow(){
            this.v_row ={}
            this.qryTabData()
        } ,
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        nextGen(row,index){
            this.$confirm( '你确定要下推生成领料出库单吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                let v_action ='OUTSTK' 
                this.$axios({
                    method: 'post',
                    url: 'xuper_auth/next_generate',
                    data: { corpid:this.v_corpid,p_idseq:row['IDSEQ'], p_action:v_action},
                }).then(res=>{ 
                    if (res.code=='200'){        
                        this.$notify({
                            title: '成功',
                            message: '已成功下推领料出库单，请到领料出库单界面中查看' ,
                            type: 'success'
                        });
                    }else{
                        this.promptWin =true
                        this.prompt ='下推失败！'+res.result
                    }
                })
 
            }).catch(err=>{})
        },
        ordChg(val){
            this.ordArr.some(item=>{
                if (item['PKSEQ'] ==val){
                    this.dtlRow['PRDNO']=item['MATNO']
                    this.dtlRow['PRDNM']=item['MATNM']
                    this.dtlRow['PRDQTY']=item['QTY']
                    this.dtlRow['SRCIDNO']=item['IDNO']
                    this.dtlRow['SRCLSTSEQ']=item['LSTSEQ']
                }
            })
        },
        //分配
        alloCate(){
            let v_bool =false
            if (!this.supval ){
                this.promptWin =true
                this.prompt ='分配建议供应商不能为空'
            }else if (!this.dateval ){
                this.promptWin =true
                this.prompt ='分配建议到货日期不能为空'
            }else{
                this.reqData.some(item=>{
                    if (item['SEL']=='Y'){
                        v_bool =true
                    }
                })
                if (!v_bool ){
                    this.promptWin =true
                    this.prompt ='请选择记录'
                }else{
                    let v_supnm =''
                    this.reqData.forEach(item=>{
                        if (item.SEL=='Y'){
                            item['SUPNO'] =this.supval
                            this.supArr.some(item=>{if (item['IDNO']==this.supval) v_supnm= item['SUPNM']})
                            item['SUPNM'] =v_supnm
                            item['SHPDTTM'] =this.dateval
                            item['RMK'] =this.rmkval
                        }
                    })
                }
            }
        },
        //全选
        selChg(){
            this.reqData.forEach(item=>{
                item['SEL']=this.allSel
            })
        },
        // 明细select框改变时
        comChg(key,val,arr){
          if (key =='STKNO'){
            arr.some(item=>{
              if (item['CODE']==val)
                this.v_stknm  =item['CNAME']
            })
            //console.log(key,val,JSON.stringify(arr) )
          }
          
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt ='请选择报表'
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
        supChg(val){
            this.supArr.some(item=>{
                if (item['IDNO']==val){
                    this.dtlRow['SUPNM']=item['SUPNM']
                }
            })
        },
 
        dtlSure(){
            let stfgBool=true
            this.notDtl.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.dtlRow[item.FLDNO] ){
                    stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    stfgBool =true  
                }
            })
            //发起保存请求   
            if (stfgBool) {  
                this.perWin =false
                if (this.perFlag==='edit' ){ //编辑时要替换数组记录
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlRow,{STKNM:this.v_stknm}) )
                }else{
                    this.dtlData.push(Object.assign(this.dtlRow,{STKNM:this.v_stknm}))
                }
            }
        },
        perClick(row){
            
        },
        perEdit(row ,index){
            this.dtlRow=JSON.parse(JSON.stringify(row))
            this.perWin=true
            this.perFlag='edit'
            this.rowIndex=index
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            })
        } ,
        perDel(row,index){
            this.$confirm('你确定要删除此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.dtlData.splice(index,1)
                this.delArr.push(row)
            }).catch(()=>{})
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'407576',p_cond:' and lstseq in (1,2)',p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.mainRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool) {    
                let obj_ ={},amt_=0,actamt_=0
  
                Object.assign(obj_,vm.mainRow,{ 'CORPID':this.v_corpid }) 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(obj_), p_table:'pc_pick',frmid:'407576'},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        //明细保存：批量保存  res.idseq
                         this.$axios({   
                            method: 'post',
                            url:'xuper_auth/batDtlSave2',
                            data: {p_json:JSON.stringify(this.dtlData), p_table:'pc_pickdtl',p_idseq:res.idseq,p_action:'S' },
                         }).then(res=>{
                             if (res.code!=='200'){
                                 this.promptWin=true
                                 this.prompt=res.result
                             }
                         })
                         //明细删除
                         if (this.delArr.length>0) {
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delArr), p_table:'pc_pickdtl',p_idseq:res.idseq,p_action:'D' },
                            })
                         }        
                        vm.drawer =false   
                        vm.qryTabData()
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            }
 
        },
        //状态审核
        recSet(row,val){
            let stfg_ =val==='Y'?'审核':'反审核'
            this.$confirm('你确定要'+stfg_+'此行记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'pc_pick',p_cond:' set stfg=\''+val+'\'' },
                }).then(res=>{      
                    if(res.code =='200')  {           
                        vm.qryTabData()     
                    }else{
                        this.promptWin=true
                        this.prompt=res.message
                    }        
                }) 
                 
            }).catch(()=>{})
        },
        //订单明细
        getPcList(cond){
            this.v_loading =true
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+' order by '+this.selparam+' desc',p_table:'V_pc_pick'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.tabref.doLayout()
                        this.v_loading=false
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.code+':'+res.result
                    this.v_loading=false
                }
                
            }) 
        },
        //查询明细数据
        getDtlData(idseq){
            this.v_loading =true
            getTabColOrData(this.v_url,'V_pc_pickdtl','idseq',idseq,'','','','',' ORDER BY MATNO').then((res) => {
                this.dtlData=[]
                this.dtlData =res.result  
                this.$nextTick(()=>{
                    this.v_loading =false
                })
            })
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promptWin=true
                this.prompt='请输入跳至页数'
            }
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
        
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.tabData = this.allData.slice(_start,_end);
        },
        //状态变更
        stfgRec(row,val,index){
            let v_comm='',cond_='',v_user='',v_dttm=''
            if (val==='Y'){
                v_comm='审核'
            }else if (val==='N'){
                v_comm='弃审'
            }else if (val==='X'){
                v_comm='删除'
            }
            if (val==='Y'){
                v_user =this.v_usernm
                v_dttm =getDate('full')
                cond_=' set stfg=\'Y\' ,chkdttm=\''+v_dttm+'\' ,chkuser=\''+v_user+'\''
            }else{
                v_user =''
                v_dttm =''
                cond_=' set stfg=\''+val+'\' , chkdttm=null  , chkuser=null'
            }
            this.$confirm('你确定要'+v_comm+'此单据吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this
                if (row['STKOUTNO'] && val=='N'){
                    this.promptWin =true
                    this.prompt ='此单据已下推领料出库单，不能弃审'
                }else {
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/updateRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'pc_pick',p_cond:cond_},
                    }).then(res=>{      
                        if(res.code =='200')  {
                            if (val=='X'){
                                this.tabData.splice(index,1)
                            }else{        
                                Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_user,CHKDTTM:v_dttm})
                            }
                        }else{
                            this.prompt=res.result
                            this.promptWin =true
                        }        
                    })
                }
            }).catch(()=>{})
             
        },
        editRec(row,val){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{ 
               this.saveFlag=false
            }
            this.mainRow =JSON.parse(JSON.stringify(row))
            this.drawer=true   
            this.getDtlData(row.IDSEQ)
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            })             
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+'  like \'%' + this.txtparam+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_edcss =='number'){
                        v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                    }else{
                        v_cond =v_cond +' and  '+item+'  like \'%'+ (this.v_row[item]).trim()+'%\''
                    }

                }
            })
            this.getPcList( cond_+ v_cond)
    
        },
        //新增 
        addRec(){
            this.drawer =true
            this.stfgCss='icon-weishenhe3'
            this.mainRow={DTTM:getDate('day'), STAFF:this.v_usernm, STFG:'N','IDTY':'401214'}
            this.saveFlag=false
            this.dtlData=[]
        },
        //状态查询
        stfgChange(){
            this.qryTabData()
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','407576','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','407576','lstseq','2','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','5','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.matCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
 
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
 
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        height:20px;
    }
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    } 
 
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:12px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
